import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { MakeMostOfMoneyContext } from '../../../../contexts/MakeMostOfMoneyContext';
import { NFT_ENDPOINT } from '../../../../utils';

export default function GenerateNFTModal({
  trancheId,
}: {
  trancheId: number | undefined;
}) {
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  const { setNftModal } = React.useContext(MakeMostOfMoneyContext);
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const navigate = useNavigate();
  const cancelRef = React.useRef<any>();

  function handleGenerateNFT() {
    setIsLoading(true);
    fetch(`${NFT_ENDPOINT}?trancheId=${trancheId}`)
      .then(() => {
        setIsLoading(false);
        navigate('/positions');
        onClose();
        setNftModal(false);
      })
      .catch((e) => {
        setIsLoading(false);
        setError('Server Error generating the image=' + e.toString());
        setNftModal(false);
      });
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        motionPreset="slideInBottom"
        isCentered
        closeOnEsc={false}
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent>
          <Box background="linear-gradient(to right, hsla(0, 100%, 64%, 0.06), hsla(193, 100%, 50%, 0.06))">
            <ModalHeader>Generate NFT</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              Heey, would you like to get a cool NFT generated by AI for your
              position?
              <br />
              {error ? <Text color="red">{error}</Text> : null}
            </ModalBody>

            <ModalFooter>
              <Button ref={cancelRef} onClick={onClose}>
                No
              </Button>
              <Button
                variant={'primary'}
                ml={3}
                onClick={handleGenerateNFT}
                isLoading={isLoading}
              >
                &nbsp; Yes &nbsp;
              </Button>
            </ModalFooter>
          </Box>
        </ModalContent>
      </Modal>
    </>
  );
}
